import type { Translations } from './translations/en';
import en from './translations/en';
import zh from './translations/zh';

export const languages = {
  en: 'English',
  zh: '中文'
} as const;

export type Language = keyof typeof languages;

export const defaultLang = 'en' as const;

// 语言区域映射
export const locales: Record<Language, string> = {
  en: 'en-US',
  zh: 'zh-CN'
};

export const translations: Record<Language, Translations> = {
  en,
  zh
}; 